import React from "react";
import { Link } from "react-router-dom";
import { whatsappUrl } from "../data/services";

const StickyCta = () => (
  <div className="mobile-sticky-cta" aria-label="Quick contact options">
    <a href={whatsappUrl} target="_blank" rel="noreferrer">
      WhatsApp
    </a>
    <Link to="/contact">Enquiry Form</Link>
  </div>
);

export default StickyCta;
